export const RouteMap = {
  ROOT: '/',
  HOME: '/home',
  LOGIN: '/login',
  DESKTOP_AUTH: '/desktop-auth',
  SETTINGS: '/settings',
  SETTINGS_TAGS: '/settings/tags',
  SETTINGS_DESKTOP_APP: '/settings/desktop-app',
  SUPPORT: '/support',
  NOTE: '/note',
  MY_NOTES: '/my-notes',
  SHARED_WITH_ME: '/shared-with-me',
  FAVORITES: '/my-notes/favorites',
  SAVED_NOTES: '/saved-notes',
  PLAN: '/plan',
  /** Anchor ID for the plans section on the Plan page */
  PLAN_ANCHOR: 'plans-section',
  CHECKOUT: '/checkout',
  CHECKOUT_SUCCESS: '/checkout-success',
  EMAIL_ACTION: '/email-action',
  BETA: '/beta',
  RECORD: '/record',
  AUDIO_RECORDING: '/audio-recording',
  BETA_VIDEO_UPLOAD: '/beta/video-upload',
  BETA_SCREEN_RECORDING: '/beta/screen-recording',
  BETA_AUDIO_RECORDING: '/beta/audio-recording',
  BETA_MODEL_GUIDANCE: '/beta/about-me',
  BETA_SECOND_BRAIN: '/beta/second-brain',
  BETA_VIBE_CODE: '/beta/vibe-code',
  BETA_ZAPIER: '/beta/zapier',
  BETA_SMART_TAGS: '/beta/smart-tags',
  FOLDERS: '/folders',
  FOLDER_DETAIL: '/folders/:folderId',
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_DETAIL: '/organizations/:organizationId',
  ACCEPT_INVITE: '/accept-invite',
  TRIAL_WELCOME: '/trial-welcome',
  ONBOARDING: '/onboarding',
  FIRST_VIDEO: '/first-video',
  PUBLIC_NOTE: '/public/:token',
  PLUGIN_REDIRECT: '/pluginUrls',
  PLAYGROUND: '/playground',
  WHATS_NEW: '/whats-new',
  WHATS_NEW_DETAIL: '/whats-new/:slug',
};
